export enum StrategyRequestLegValidityType{
    Undefined = 'UNDEFINED',
    Day = 'DAY',
    GoodTillCancel = 'GOODTILLCANCEL',
    ImmediateOrCancel = 'IMMEDIATEORCANCEL',
    FillOrKill = 'FILLORKILL',
    GoodTillDate = 'GOODTILLDATE',
    AtTheClose = 'ATTHECLOSE',
    GoodForAuction = 'ATTHECLOSE'
}